import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { ShieldCheck, Info, ExternalLink } from 'lucide-react';
import './PrivacyPolicy.css'; // Reusing legal page styles

const Disclaimer = () => {
    return (
        <motion.div
            className="legal-page"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Helmet>
                <title>Disclaimer | Kodebuild</title>
                <meta name="description" content="Important legal disclaimers and information regarding the use of the Kodebuild website and our external recommendations." />
                <link rel="canonical" href="https://kodebuildtech.com/disclaimer" />
            </Helmet>
            <div className="container">
                <header className="legal-header">
                    <h1>Legal Disclaimer</h1>
                    <p>Last Updated: March 21, 2026</p>
                </header>

                <div className="legal-content">
                    <section>
                        <div className="legal-icon-title">
                            <Info className="legal-icon" />
                            <h2>1. General Information</h2>
                        </div>
                        <p>
                            The information provided by Kodebuild ("we," "us," or "our") on our website is for general informational purposes only.
                            All information on the Site is provided in good faith, however, we make no representation or warranty of any kind,
                            express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any
                            information on the Site.
                        </p>
                    </section>

                    <section>
                        <div className="legal-icon-title">
                            <ExternalLink className="legal-icon" />
                            <h2>2. External Links & Affiliate Disclosure</h2>
                        </div>
                        <p>
                            The Site may contain (or you may be sent through the Site) links to other websites or content belonging to or originating from third parties.
                            Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.
                        </p>
                        <p>
                            <strong>Affiliate Disclosure:</strong> Some of the links on this website are affiliate links, such as our recommendations for web hosting services (e.g., Hostinger).
                            This means that if you click on the link and purchase the item, we will receive an affiliate commission at no extra cost to you.
                            We only recommend products or services we believe will add value to our clients and readers. This disclosure is provided in accordance with
                            the Federal Trade Commission's 16 CFR, Part 255: "Guides Concerning the Use of Endorsements and Testimonials in Advertising."
                        </p>
                    </section>

                    <section>
                        <div className="legal-icon-title">
                            <ShieldCheck className="legal-icon" />
                            <h2>3. Professional Disclaimer</h2>
                        </div>
                        <p>
                            The Site cannot and does not contain technical or software engineering advice. The technical information is provided for general
                            informational and educational purposes only and is not a substitute for professional advice. Accordingly, before taking any
                            actions based upon such information, we encourage you to consult with the appropriate professionals. The use or reliance of
                            any information contained on the Site is solely at your own risk.
                        </p>
                    </section>

                    <section className="legal-booster">
                        <div className="legal-icon-title">
                            <ShieldCheck className="legal-icon" />
                            <h2>5. Professional Standards</h2>
                        </div>
                        <p>
                            Our commitment at Kodebuild is to provide high-end tech consultation and engineering 
                            that aligns with global industry standards. While we strive for absolute accuracy 
                            in our publications and recommendations, the rapid evolution of technology 
                            requires constant vigilance and professional verification. We are here to 
                            support your digital acceleration with integrity and transparency.
                        </p>
                    </section>
                </div>
            </div>
        </motion.div>
    );
};

export default Disclaimer;
